<template>
  <div class="w-full max-w-270 text-app-color">
    <div class="w-full p-15 pt-10 pb-40 md:p-30 rounded-20 border border-grey-300"
         :class="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    >
      <div>
        <p class="text-26 font-semibold leading-none mb-10">Free Trial.</p>
        <p class="text-14">All features for a <br> limited time of 15 days.</p>
        <div class="flex mt-20">
          <div class="text-35 font-bold leading-none">
            <span>$0</span>
          </div>
          <p class="leading-none ml-15 font-bold text-14">per month</p>
        </div>
      </div>

      <div class="text-center mt-35">
        <button
          class="border-2 transition-color duration-300 rounded-full px-20 py-10 font-medium"
          :class="isDraculaTheme
            ? 'bg-notebooks-dracula-link border-notebooks-dracula-link text-grey-main'
            : isDarkMode ? 'bg-link-color border-link-color' : 'border-blue-dark'"
          :disabled="true"
        >
          Current plan
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  setup () {
    const { getters, state } = useStore()

    const isDarkMode = computed(() => getters.isDarkMode)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')

    return {
      isDarkMode,
      isDraculaTheme
    }
  }
})
</script>
